import { isRemovedSlug } from "./isRemovedSlug";
import { unpublishedPosts } from "./unpublishedPosts";
import React from 'react';
import { navigate } from "gatsby"

export const collectChildrenToString = (node, res) => {
    let accum = res
    if (node.data) {
        accum += node.data;
    }
    if (node.children) {
        for (let child of node.children) {
            if (child.data) {
                accum += child.data;
            }
            if (child.children) {
                accum = collectChildrenToString(child, accum)
            }
        }
    }
    return accum;
}

function asciiParse(str) {
    const asciiMap = {
        "%20": " ",
        "%21": "!",
        "%22": "\"",
        "%23": "#",
        "%24": "$",
        "%25": "%",
        "%26": "&",
        "%27": "'",
        "%28": "(",
        "%29": ")",
        "%2A": "*",
        "%2B": "+",
        "%2C": ",",
        "%2D": "-",
        "%2E": ".",
        "%2F": "/",
        "%3A": ":",
        "%3B": ";",
        "%3C": "<",
        "%3D": "=",
        "%3E": ">",
        "%3F": "?",
        "%40": "@",
        "%5B": "[",
        "%5C": "\\",
        "%5D": "]",
        "%5E": "^",
        "%5F": "_",
        "%60": "`",
        "%7B": "{",
        "%7C": "|",
        "%7D": "}",
        "%7E": "~",
    };
    return str.replace(/%[0-9A-F]{2}/g, (match) => asciiMap[match]);
}

const cleanUrlString = (str) => {
    const validUrlCharacters = /[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]/;

    let sanitizedString = "";

    for (let i = 0; i < str.length; i++) {
        const char = str.charAt(i);

        if (!validUrlCharacters.test(char)) {
            continue;
        }

        sanitizedString += char;
    }

    return sanitizedString;
}

const replaceSpecialEncoding = (str) => {
    let res = decodeURIComponent(str)
    res = res.trim();
    try {
        if (res.includes("%")) {
            res = decodeURIComponent(res)
        }
        if (res.includes("%")) {
            res = decodeURIComponent(res)
        }
    } catch (error) {
        if (error.toString().includes("URI malformed")) {
            res = cleanUrlString(res)
        }
        try {
            res = decodeURIComponent(res)
        } catch (error) {
            console.log(error);
        }
    }

    if (res.includes(" ")) {
        res = res.replaceAll(" ", "%20")
    }
    return res;
}


export const handleInPostLinks = (node) => {
    // handle internal without trailing slash
    if (node.name === 'a' &&
        node.attribs &&
        node.attribs.href &&
        (node.attribs.href.includes("donotpay") || node.attribs.href.includes("/learn"))
        && !node.attribs.href.endsWith("/")) {
        node.attribs.href = node.attribs.href + "/";
    }

    // correct typos by content teams
    if (node.name === 'a' && node.attribs && node.attribs.href) {
        // HANDLE INTERNAL LINKS
        if (node.attribs.href.includes("learn/virtual-credit-card-free")) {
            node.attribs.href = node.attribs.href.replace("virtual-credit-card-free", "free-trial-credit-card");
        }
        if (node.attribs.href.includes("learn/late-delivery-refund")) {
            node.attribs.href = node.attribs.href.replace(/late-delivery-refund$/g, "late-delivery-refunds/");
            node.attribs.href = node.attribs.href.replace(/late-delivery-refund\/$/g, "late-delivery-refunds/");
        }
        if (node.attribs.href.includes("learn/gift-card-to-cash")) {
            node.attribs.href = node.attribs.href.replace("gift-card-to-cash", "convert-gift-card-to-cash");
        }
        if (node.attribs.href.includes("learn/what-is-the-best-way-to-contact-your-government-representatives")) {
            node.attribs.href = node.attribs.href.replace(/what-is-the-best-way-to-contact-your-government-representatives/g, "what-is-the-best-way-to-contact-your-representatives");
        }
        if (node.attribs.href.includes("where-can-I-file-a-complaint-against-my-landlord")) {
            node.attribs.href = node.attribs.href.replace(/where-can-I-file-a-complaint-against-my-landlord/g, "where-can-i-file-a-complaint-against-my-landlord");
        }
        if (node.attribs.href.includes("how-much-of-a-raise-should-I-ask-for")) {
            node.attribs.href = node.attribs.href.replace(/how-much-of-a-raise-should-I-ask-for/g, "how-much-of-a-raise-should-i-ask-for");
        }
        if (node.attribs.href.includes("where-can-I-exchange-my-burnt-money")) {
            node.attribs.href = node.attribs.href.replace(/where-can-I-exchange-my-burnt-money/g, "where-can-i-exchange-my-burnt-money");
        }
        if (node.attribs.href.includes("learn/manage-subscriptions")) {
            node.attribs.href = node.attribs.href.replace(/manage-subscriptions/g, "how-to-cancel");
        }
        if (node.attribs.href.includes("learn/recover-password") || node.attribs.href.includes("learn/recover-passwords")) {
            node.attribs.href = node.attribs.href.replace(/recover-passwords?/g, "recover-account-passwords");
        }
        if (node.attribs.href.includes("learn/refunds/")) {
            node.attribs.href = node.attribs.href.replace(/refunds/g, "chargebacks-and-refunds");
        }
        if (node.attribs.href.includes("/hilton-complaints/")) {
            node.attribs.href = node.attribs.href.replace(/hilton-complaints/g, "hilton-complaints-2");
        }
        if (node.attribs.href.includes("learn/brazillian-consulate-miami")) {
            node.attribs.href = node.attribs.href.replace(/brazillian-consulate-miami/g, "brazilian-consulate-miami");
        }
        if (node.attribs.href.includes("learn/item-return-request")) {
            node.attribs.href = node.attribs.href.replace(/item-return-request$/g, "item-return-requests/");
            node.attribs.href = node.attribs.href.replace(/item-return-request\/$/g, "item-return-requests/");
        }
        if (node.attribs.href.includes("learn/living-trust-/")) {
            node.attribs.href = node.attribs.href.replace(/living-trust-\/$/g, "living-trust-michigan/");
        }
        if (node.attribs.href.includes("learn/how-to-contact-my-senator")) {
            node.attribs.href = node.attribs.href.replace(/how-to-contact-my-senator\/$/g, "contact-my-senator/");
            node.attribs.href = node.attribs.href.replace(/how-to-contact-my-senator$/g, "contact-my-senator/");
        }
        if (node.attribs.href.includes("http://donotpay.com")) {
            node.attribs.href = node.attribs.href.replace(/http:\/\/donotpay/g, "https://donotpay");
        }
        if (node.attribs.href.includes("http://www.donotpay.com")) {
            node.attribs.href = node.attribs.href.replace(/http:\/\/www.donotpay/g, "https://donotpay");
        }
        if (node.attribs.href.includes("https://www.donotpay.com")) {
            node.attribs.href = node.attribs.href.replace(/https:\/\/www.donotpay/g, "https://donotpay");
        }
        if (node.attribs.href.includes("learn/living-trust-oklahoma")) {
            node.attribs.href = node.attribs.href.replace(/living-trust-oklahoma/g, "living-trust-in-oklahoma");
        }
        if (node.attribs.href.includes("how-to-sue-in-small-claims-court")) {
            node.attribs.href = node.attribs.href.replace(/how-to-sue-in-small-claims-court/g, "how-to-file-a-small-claims-court-action");
        }
        if (node.attribs.href.includes("learn/can-you-go-to-jail-for-not-paying-child")) {
            node.attribs.href = node.attribs.href.replace(/%2520/g, "-");
        }
        // there should be no spaces in internal links
        if (node.attribs.href.includes("donotpay") && node.attribs.href.includes(" ")) {
            node.attribs.href = node.attribs.href.replace(/%20/g, "").replace(/ +/g, "");
        }
        if (node.attribs.href.includes("donotpay") && node.attribs.href.includes("%255D")) {
            node.attribs.href = node.attribs.href.replace(/%255D\//g, "");
        }
        if (node.attribs.href.includes("donotpay") && node.attribs.href.includes("%5D/")) {
            node.attribs.href = node.attribs.href.replace(/%5D\//g, "");
        }
        
        // HANDLE BOTH INTERNAL AND EXTERNAL LINKS
        // handle both internal and external links
        if (node.attribs.href.includes("%")) {
            node.attribs.href = replaceSpecialEncoding(node.attribs.href)
        }
        // HANDLE EXTERNAL LINKS
        // handle space in external links
        if (!node.attribs.href.includes("donotpay") && node.attribs.href.trim().includes(" ")) {
            node.attribs.href = node.attribs.href.replaceAll(" ", "%20")
        }

        // HANDLE REMOVALS
        if (node.attribs.href.includes("https://donotpay.com/learn/")) {
            const slug = node.attribs.href.replace("https://donotpay.com/learn/", "").replace("/", "");
            if (unpublishedPosts.includes(slug) || isRemovedSlug(slug)) {
                node.name = "span";
                delete node?.attribs?.href;
            }
        }
    }
    if (
        node.name === 'a' &&
        node.attribs &&
        node.attribs.href &&
        node.attribs.href.includes("donotpay.com") &&
        !node.attribs.href.includes("donotpay.com/business/") &&
        !node.attribs.href.includes("donotpay.com/about/") &&
        !node.attribs.href.includes("learn") &&
        !node.attribs.href.endsWith(".com") &&
        !node.attribs.href.endsWith(".com/")
    ) {
        const btnText = collectChildrenToString(node, "");
        return <button
            className="link-button"
            style={{
                backgroundColor: "transparent",
                backgroundRepeat: "no-repeat",
                border: "none",
                cursor: "pointer",
                overflow: "hidden",
                outline: "none",
                color: "#e01efee8",
                fontWeight: "inherit",
                textDecoration: "underline",
                padding: 0,
                fontSize: "inherit",
            }}
            onClick={() => {
                const ctaUrl = node?.attribs?.href || "https://donotpay.com/login/"
                navigate(ctaUrl)
            }}
        >
            {btnText}
        </button >
    }

    // external links to be opened in new tab
    if (node.name === 'a' && node.attribs && node.attribs.href && !node.attribs.href.includes("donotpay.com")) {
        node.attribs.target = "_blank";
    }
}

